module.exports = __webpack_public_path__ + "img/signal-good.c6585fc8.svg";